module.exports = __webpack_public_path__ + "img/home6Img3.548ec957.png";